import { createAction, props } from '@ngrx/store';
import { CreateUserErrors } from '../user-session/user-session.state';

export const submitUsernameForPasswordRecovery = createAction(
  '[Forgot Password Page] Submit Username For Password Recovery',
  props<{ username: string }>(),
);

export const submitUsernameForPasswordRecoverySuccess = createAction(
  '[Forgot Password Page] Submit Username For Password Recovery Success',
);

export const submitUsernameForPasswordRecoveryError = createAction(
  '[Forgot Password Page] Submit Username For Password Recovery Error',
);

export const resetPassword = createAction(
  '[Reset Password Page] Reset Password',
  props<{ password: string; token: string }>(),
);

export const resetPasswordError = createAction(
  '[Auth API] Reset Password Error',
  props<{ errors: CreateUserErrors }>(),
);
